'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityList = undefined;

var _sagaTools = require('@classpass/saga-tools');

var activityList = exports.activityList = (0, _sagaTools.makeEntityScaffold)('SAGA.API.ACTIVITY_LIST', function (client, options) {
  return client.activities.getList(options).then(function (data) {
    return data.activities;
  });
}); /* eslint-disable import/prefer-default-export */